import React from 'react';
import LoginProvider, { formDefaultValues } from 'providers/LoginProvider';
import { Route, Switch, Redirect } from 'react-router-dom';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import ResetCode from './pages/ResetCode';
import Login from './pages/LoginPage';
import WhiteLabelWrapper from './components/shared/WhiteLabelWrapper';
import WhiteLabelProvider from 'providers/WhiteLabelProvider';

export default function LoginApp() {
  return (
    <LoginProvider defaultValues={formDefaultValues}>
      <WhiteLabelProvider>
        <WhiteLabelWrapper login>
          <Switch>
            <Route exact path="/clock/web/login" component={Login} />
            <Route path="/clock/web/login/password/forgot" component={ForgotPassword} />
            <Route path="/clock/web/login/password/reset" component={ResetPassword} />
            <Route path="/clock/web/login/password/code" component={ResetCode} />
            <Redirect from="/" to="/clock/web/login" />
          </Switch>
        </WhiteLabelWrapper>
      </WhiteLabelProvider>
    </LoginProvider>
  );
}
